// @flow

import React from 'react';
import type { Node } from 'react';
import styled from 'styled-components';
import { breakLine, Color, flex, Fonts, p12, topMargin, topPadding, Width } from 'styles';

const Wrapper = styled.section`
  ${topPadding(47, 80, 120)};
  h2,
  h3 {
    text-align: center;
    font-size: 2.4rem;
    @media print, screen and (min-width: ${Width.BREAK_MD}px) {
      font-size: 2.8rem;
    }
  }
  > div {
    &:first-of-type {
      margin-top: 48px;
      ${flex()};
      flex-direction: column;
      @media print, screen and (min-width: ${Width.BREAK_MD}px) {
        justify-content: space-between;
        align-items: flex-start;
        flex-direction: row;
        max-width: 800px;
        margin-left: auto;
        margin-right: auto;
      }

      @media print, screen and (min-width: ${Width.BREAK_XL}px) {
        max-width: unset;
      }
    }

    &:nth-of-type(2) {
      ${flex()};
      ${topMargin(40, 32)};
    }

    &:nth-of-type(3) {
      margin-top: 16px;
      ${p12};
      text-align: center;
    }
  }
`;

const ListItem = styled.div`
  ${flex()};
  flex-direction: column;
  margin-top: 32px;
  max-width: 380px;

  &:nth-of-type(1) {
    margin-top: 0;
  }

  @media print, screen and (min-width: ${Width.BREAK_MD}px) {
    max-width: unset;
    margin-top: 0;
    flex: 0 0 auto;
    width: 213px;
  }
  @media print, screen and (min-width: ${Width.BREAK_XL}px) {
    width: 28%;
  }
  > div {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    ${flex()};
    background: linear-gradient(180deg, rgba(161, 174, 229, 0.5) 0%, rgba(255, 255, 255, 0) 100%), #290d6d;
    color: ${Color.WHITE};
    ${Fonts.POPPINS};
    font-size: 1.8rem;
    line-height: 1;
    font-weight: 700;
    margin-bottom: 16px;
    pointer-events: none;
  }

  * {
    text-align: center;
  }

  h3 {
    ${breakLine(false, true, false)};
    font-size: 2rem;
  }
`;

type Props = {
  title: Node,
  list: Array<Node | string>,
  buttons: Node,
  disclaimer?: Node | string,
};

const ThreeItemNumberedList = ({ title, list, buttons, disclaimer, ...rest }: Props) => (
  <Wrapper {...rest}>
    {title}
    <div role="list">
      {list.map((item, index) => (
        <ListItem key={`ThreeItemNumberedList-${index}`} role="listitem">
          <div>{index + 1}</div>
          {item}
        </ListItem>
      ))}
    </div>
    <div>{buttons}</div>
    <div>{disclaimer}</div>
  </Wrapper>
);

export default ThreeItemNumberedList;
